import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '@wayout-admin/util';
import { map, Observable, of, tap } from 'rxjs';
import { AssetConfigurationDto, ConfigurationDocumentType, ImageUploadDto } from '../model-dto';

@Injectable({ providedIn: 'root' })
export class AssetService {
	private readonly http = inject(HttpClient);
	private readonly environment = inject(ENVIRONMENT);
	private readonly baseUrl = `${this.environment.baseApiUrl}/admin/asset`;

	uploadImage(formData: FormData) {
		return this.http.post<ImageUploadDto>(`${this.baseUrl}/upload`, formData);
	}

	deleteImage(imageUrl: string): Observable<void> {
		const imageName = imageUrl.split('/images/')[1];
		return this.http.delete<void>(`${this.baseUrl}/images/${imageName}`);
	}

	getAllImages(): Observable<string[]> {
		return this.http
			.get<ImageUploadDto[]>(`${this.baseUrl}/images`)
			.pipe(map((images) => images.map((image) => image.imageUrl)));
	}

	saveConfiguration(json: string, language: string, type: ConfigurationDocumentType): Observable<void> {
		return this.http.post<void>(`${this.baseUrl}/configuration`, { json, language, type });
	}

	getConfiguration(language: string, type: ConfigurationDocumentType): Observable<AssetConfigurationDto> {
		return this.http.get<AssetConfigurationDto>(`${this.baseUrl}/configuration`, { params: { language, type } });
	}

	getConfigurationMetadata(
		language: string,
		type: ConfigurationDocumentType
	): Observable<{ [key: string]: string } | null> {
		return this.http.get<{ [key: string]: string } | null>(`${this.baseUrl}/configuration/metadata`, {
			params: { language, type },
		});
	}

	publishConfiguration(language: string, type: ConfigurationDocumentType): Observable<void> {
		return this.http.get<void>(`${this.baseUrl}/configuration/publish`, { params: { language, type } });
	}
}
